import * as React from 'react';
import Alert from '@material-ui/lab/Alert';
import { PropTypes } from 'prop-types';

// Parametros props
//type: tipo de mensaje  {/* severity: error,  warning, info, success*/}
//title: Titulo de el message
//msg: Mensaje a Mostrar

AlertsTitle.propTypes = {
  type: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  msg: PropTypes.string.isRequired
};

AlertsTitle.defaultProps = {
  type: "info",
  title: "Título:",
  msg: 'No hay mensaje'
}

export default function AlertsTitle(props) {
  return (
    <div style={{ width: '100%', textAlign: 'center', marginBottom: 16 }}>
      <Alert severity={props.type} style={{ margin: '0 auto' }}>
        <strong>{props.title}</strong> {" "} {props.msg}
      </Alert>
    </div>
  );
}